import { render } from "./StepQuestionsGeneric.vue?vue&type=template&id=16b0b14c"
import script from "./StepQuestionsGeneric.vue?vue&type=script&lang=js"
export * from "./StepQuestionsGeneric.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__